import { render, staticRenderFns } from "./HowToBuy.vue?vue&type=template&id=18ab2dda"
import script from "./HowToBuy.vue?vue&type=script&lang=js"
export * from "./HowToBuy.vue?vue&type=script&lang=js"
import style0 from "./HowToBuy.vue?vue&type=style&index=0&id=18ab2dda&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports